import {Inject, Injectable, InjectionToken} from '@angular/core';
import {environment} from '../../../environments/environment';

export type MonetizationMode = 'web-checkout' | 'consumption-only' | 'google-play-billing';
export type MonetizationLinkPurpose = 'commercial' | 'authentication' | 'legal' | 'support' | 'social';

export const MONETIZATION_MODE = new InjectionToken<MonetizationMode>('MONETIZATION_MODE', {
  providedIn: 'root',
  factory: () => environment.monetizationMode,
});

@Injectable({providedIn: 'root'})
export class MonetizationPolicyService {
  constructor(@Inject(MONETIZATION_MODE) readonly mode: MonetizationMode) {}

  get isConsumptionOnly(): boolean {
    return this.mode === 'consumption-only';
  }

  get canUseWebCheckout(): boolean {
    return this.mode === 'web-checkout';
  }

  canRenderLink(purpose: MonetizationLinkPurpose): boolean {
    return purpose !== 'commercial' || this.canUseWebCheckout;
  }
}
